import { render, staticRenderFns } from "./OverviewLPG.vue?vue&type=template&id=288be552"
import script from "./OverviewLPG.vue?vue&type=script&lang=js"
export * from "./OverviewLPG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports